import PageHeader from "../components/global-components/page-header";
import Error from "../components/section-components/error";

const NotFound = () => {
	return (
		<div>
			<PageHeader headertitle="Halaman tidak ditemukan" />
			<Error />
		</div>
	);
};

export default NotFound;
